"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface RecentProduct {
  id: string;
  name: string;
  slug: string;
  price: number;
  coverImageUrl?: string;
  coverFocalX?: number;
  coverFocalY?: number;
  categoryName?: string;
  brandName?: string;
  compareAtPrice?: number;
  trackStock: boolean;
  stock: number;
  lowStockThreshold?: number;
  isFeatured: boolean;
  isOnSale: boolean;
  discountPercentage?: number;
  dealerPrice?: number | null;
  variants: { id: string; name: string; price: number; stock: number }[];
}

interface RecentlyViewedStore {
  items: RecentProduct[];
  track: (product: RecentProduct) => void;
  removeIds: (ids: string[]) => void;
  clear: () => void;
}

const MAX_ITEMS = 8;

export const useRecentlyViewedStore = create<RecentlyViewedStore>()(
  persist(
    (set) => ({
      items: [],
      track: (product) =>
        set((state) => {
          const filtered = state.items.filter((p) => p.id !== product.id);
          return { items: [product, ...filtered].slice(0, MAX_ITEMS) };
        }),
      removeIds: (ids) =>
        set((state) => ({ items: state.items.filter((p) => !ids.includes(p.id)) })),
      clear: () => set({ items: [] }),
    }),
    { name: "recently-viewed" }
  )
);
